<template>
  <teleport to="body">
    <div v-if="s.visible" class="msg-overlay" @click.self="onOverlay">
      <div class="msg-box">
        <div class="msg-icon">
          <svg v-if="s.type === 'success'" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          <svg v-else-if="s.type === 'error'" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c62828" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
          <svg v-else-if="s.type === 'confirm'" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e65100" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1560BD" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        </div>
        <div class="msg-title" v-if="s.title">{{ s.title }}</div>
        <div class="msg-text">{{ s.text }}</div>
        <div v-if="s.inputMode" style="margin-top:12px;">
          <input class="fi" v-model="s.inputValue" :placeholder="s.inputPlaceholder" ref="inputRef" @keyup.enter="onOk" />
        </div>
        <div class="msg-actions">
          <button v-if="s.type === 'confirm' || s.inputMode" class="btn btn-g" @click="onCancel">Cancelar</button>
          <button class="btn" :class="s.type === 'error' ? 'btn-p' : 'btn-p'" @click="onOk">{{ s.okLabel }}</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { inject } from 'vue';
export default {
  name: 'MsgModal',
  setup() {
    const s = inject('msgState');
    return { s };
  },
  methods: {
    onOk() {
      this.s.visible = false;
      if (this.s._resolve) this.s._resolve(this.s.inputMode ? this.s.inputValue : true);
      this.s._resolve = null;
    },
    onCancel() {
      this.s.visible = false;
      if (this.s._resolve) this.s._resolve(this.s.inputMode ? null : false);
      this.s._resolve = null;
    },
    onOverlay() {
      if (this.s.type !== 'confirm' && !this.s.inputMode) this.onOk();
    },
  }
};
</script>

<style>
.msg-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(3,43,82,.4); display: flex; align-items: center; justify-content: center;
  animation: msgFade .15s;
}
.msg-box {
  background: #fff; border-radius: 14px; padding: 32px 36px 24px;
  min-width: 340px; max-width: 460px; text-align: center;
  box-shadow: 0 12px 40px rgba(0,0,0,.2);
  animation: msgScale .2s;
}
.msg-icon { margin-bottom: 14px; }
.msg-title { font-size: 17px; font-weight: 700; color: #1a1a2e; margin-bottom: 8px; }
.msg-text { font-size: 14px; color: #555; line-height: 1.6; white-space: pre-line; }
.msg-actions { margin-top: 20px; display: flex; gap: 10px; justify-content: center; }
.msg-actions .btn { min-width: 110px; }
@keyframes msgFade { from { opacity: 0; } to { opacity: 1; } }
@keyframes msgScale { from { transform: scale(.92); opacity: 0; } to { transform: scale(1); opacity: 1; } }
</style>
